import type { ReactNode } from 'react';

import { Box } from '@mantine/core';

export const PublicLayout = ({ children }: { children: ReactNode }) => (
  <Box bg='beige.1' style={{ minHeight: '100vh' }}>
    {children}
  </Box>
);
